import type { RouteObject } from 'react-router-dom';
import { contestRoutes } from './contest.routes';
import { dashboardRoutes } from './dashboard.routes';
import { fullScreenRoutes } from './fullScreen.routes';
import { guestRoutes } from './guest.routes';
import { mainSectionRoutes } from './mainSection.routes';
import { programRoutes } from './program.routes';
import { operationRoutes } from './operation.routes';
import { receptionRoutes } from './reception.routes';
import { checkInRoutes } from './checkIn.routes';
import { statsRoutes } from './stats.routes';
import { userRoutes } from './user.routes';
import { storeRoutes } from './store.routes';
import { paymentsRoutes } from './payments.routes';
import { systemRoutes } from './system.routes';
import { myRoutes } from './my.routes';

export const guestRouteModules: RouteObject[] = [guestRoutes];

export const appRouteModules: RouteObject[] = [
	dashboardRoutes,
	mainSectionRoutes,
	userRoutes,
	contestRoutes,
	programRoutes,
	operationRoutes,
	receptionRoutes,
	storeRoutes,
	paymentsRoutes,
	statsRoutes,
	systemRoutes,
	myRoutes
];

export const fullScreenRouteModules: RouteObject[] = fullScreenRoutes;

// 현장 체크인 전용 라우트 (appRouteModules 제외, Route.tsx의 authed 서브트리에 직접 배치)
export { checkInRoutes };
